import { Box, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import { formatCurrency } from 'components/DataGrid/operators/formatNumbers'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'

interface AggregateCurrencyCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const AggregateCurrencyCell: FC<AggregateCurrencyCellProps> = ({ params, densityStyles }) => {
  // Check if this is an aggregation row (either MUI auto-generated or our server aggregation row)
  //@ts-ignore
  const isAggregationRow = params?.rowNode?.isAutoGenerated || params?.row?.isAggregationRow

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'right',
        alignItems: 'center',
        height: '100%',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      <Typography
        sx={{
          fontSize: densityStyles?.fontSize,
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          fontWeight: isAggregationRow ? 600 : undefined,
          color: params?.value > 0 && isAggregationRow ? 'text.success' : '',
        }}
      >
        {formatCurrency(params.value)}
      </Typography>
    </Box>
  )
}
export default AggregateCurrencyCell
